import React, { useEffect, useRef, useState } from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
// import { useUserProvider } from '@/context/UserProvider';
import { useWindowSize } from 'react-use';
import { DownloadStoriesPreviewModel } from '@/types/home';
import CustomersTalkUsContent from './CustomersTalkUsContent';
import useSearchAccountGuide from '../Dashboard/useSearchAccountGuide';

const FAQContent = dynamic(() => import('./FAQContent'), { ssr: true });
const DownloadInstagramContent = dynamic(() => import('./DownloadInstagramContent'), { ssr: true });
const TopSearchContent = dynamic(() => import('./TopSearch'), { ssr: true });
const ChooseContent = dynamic(() => import('./ChooseContent'), { ssr: true });
const GeneralExampDownloadContent = dynamic(() => import('./GeneralExampDownloadContent'), { ssr: true });
const WhyDownloadStoriesContent = dynamic(() => import('./WhyDownloadStoriesContent'), { ssr: true });
const InstagramActivityTrackerContent = dynamic(() => import('./InstagramActivityTracker'), { ssr: true });
const BestTipsContent = dynamic(() => import('./BestTipsContent'), { ssr: true });
const DownloadStoriesBottomContent = dynamic(() => import('./DownloadStoriesBottomContent'), { ssr: true });

const InstagramTrackerSubContent = ({ data }: { data?: any }) => {
  const [contentData, setContentData] = useState<DownloadStoriesPreviewModel>(data?.contentData);
  const searchResultRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const { onSearchAccount, searchAccountLoading, renderPrivateAccountModal, renderAddAccountModal } =
    useSearchAccountGuide();

  // const { isLogin, onOpenLoginModal } = useUserProvider();
  const [searchStr, setSearchStr] = useState('');
  const { width } = useWindowSize();
  const [inputVisible, setInputVisible] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    setContentData(data?.contentData);
  }, [data]);

  const onValueChanged = (e?: string) => {
    setSearchStr(e ?? '');
  };

  const onSearch = (e?: string) => {
    setSearchStr(e ?? '');
    setOpenModal(true);
  };

  return (
    <>
      <CommonBackContent style={{ minHeight: '100vh' }}>
        <TopSearchContent
          topInfo={contentData?.contentInfo?.hero}
          loading={searchAccountLoading}
          searchVal={searchStr}
          onSearchClick={onSearchAccount}
          onValueChanged={onValueChanged}
          onInputVisibleChanged={(visible) => setInputVisible(visible)}
        />

        <DownloadInstagramContent data={contentData?.contentInfo['section-1']} />
        <ChooseContent data={contentData?.contentInfo['section-2']} />
        <GeneralExampDownloadContent data={contentData?.contentInfo['section-3']} />
        <WhyDownloadStoriesContent data={contentData?.contentInfo['section-4']} />
        <InstagramActivityTrackerContent
          contentData={contentData}
          isTracker={true}
          webBg={'https://res-front.pumpsoul.com/ins-prod/image/activity_tracker_bg_web_0110_1.webp'}
          phoneBg={'https://res-front.pumpsoul.com/ins-prod/image/activity_tracker_bg_phone_0109.webp'}
        />
        <CustomersTalkUsContent contentInfo={contentData?.contentInfo?.['section-user-reviews']} />
        {contentData?.faqList && (
          <FAQContent faqInfo={contentData?.contentInfo?.['section-faq']} faqList={contentData?.faqList} />
        )}

        <BestTipsContent
          title={contentData?.contentInfo?.['section-top-blog']?.title}
          blogList={contentData?.topBlogList}
        />
        <BestTipsContent title={contentData?.contentInfo?.['section-blog']?.title} blogList={contentData?.blogList} />
      </CommonBackContent>

      <DownloadStoriesBottomContent
        bottomInfo={contentData?.contentInfo['section-buttom']}
        loading={searchAccountLoading}
        searchVal={searchStr}
        inputVisible={inputVisible}
        onValueChanged={onValueChanged}
        onSearchClick={(e) => {
          onSearchAccount(e);
          if (searchResultRef.current) {
            window.scrollTo({
              top: searchResultRef.current.offsetTop - (width > 900 ? 180 : 150),
            });
          }
        }}
      />

      {renderAddAccountModal()}
      {renderPrivateAccountModal()}
    </>
  );
};

export default InstagramTrackerSubContent;
